import { useEffect, useState } from 'react';
import { appel } from '../api';

/**
 * En-tête du document affiché : aucune ressource externe, aucun script. Le
 * cadre `sandbox` sans permission lui retire en plus l'origine de
 * l'application, donc tout accès à la session.
 */
const ENTETE =
  '<!doctype html><meta charset="utf-8">' +
  `<meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'">` +
  '<style>body{margin:16px;background:#fff;color:#1c1917;font:15px/1.5 system-ui,sans-serif;overflow-wrap:anywhere}' +
  'table{border-collapse:collapse}td,th{padding:4px 6px;border:1px solid #e7e5e4}</style>';

/** Aperçu d'un CV Word, converti en HTML par l'API (images retirées). */
export function ApercuWord({ documentId, titre }: { documentId: string; titre: string }) {
  const [html, setHtml] = useState<string | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    setHtml(null);
    setErreur(null);
    let vivant = true;
    appel<{ html: string }>(`/documents/${documentId}/apercu`)
      .then((reponse) => vivant && setHtml(reponse.html))
      .catch((e: Error) => vivant && setErreur(e.message));
    return () => {
      vivant = false;
    };
  }, [documentId]);

  if (erreur) return <p className="erreur">{erreur}</p>;
  if (html === null) return <p className="attente">Chargement du document…</p>;
  return <iframe className="apercu" sandbox="" srcDoc={ENTETE + html} title={titre} />;
}
